import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  scrollToDate(event) {
    event.preventDefault();
    const date = event.currentTarget.dataset.date;
    const dateSection = document.getElementById(`date-${date}`);

    if (dateSection) {
      // Get the header element within the section
      const header = dateSection.querySelector(".date-group-header");

      // Calculate offset to account for fixed elements and some padding
      const offset = 120; // Increased offset to account for fixed header + navigation + padding

      // Get the element's position
      const rect = dateSection.getBoundingClientRect();
      const headerHeight = header ? header.offsetHeight : 0;

      // Calculate the final scroll position
      // We subtract the header height to ensure the entire header is visible
      const scrollPosition =
        window.pageYOffset + rect.top - offset - headerHeight;

      // Smooth scroll to the position
      window.scrollTo({
        top: Math.max(0, scrollPosition), // Ensure we don't scroll past the top
        behavior: "smooth",
      });
    }
  }
}
